import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import axios from '../utils/api';

const StoreSettingsContext = createContext(null);

const defaultSettings = {
  store_name: 'Pugtrail',
  contact_email: null,
  contact_phone_country: null,
  contact_phone: null,
  store_state: null,
  cod_enabled: false,
  razorpay_enabled: true,
  allow_non_india_user_isd: false,
  allow_add_to_cart: true,
  default_return_policy: 'non-returnable',
  return_policy: '',
  shipping_policy: '',
  privacy_policy: '',
  cart_messages: [
    'Free shipping',
    '10-day return policy',
    'Secure checkout',
  ],
};

export const StoreSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchPublicSettings = async () => {
      try {
        const response = await axios.get('/api/store-settings/public');
        if (isMounted && response?.data) {
          setSettings({
            ...defaultSettings,
            ...response.data,
          });
        }
      } catch (err) {
        if (isMounted) {
          setSettings(defaultSettings);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchPublicSettings();

    return () => {
      isMounted = false;
    };
  }, []);

  const value = useMemo(() => ({ settings, loading }), [settings, loading]);

  return <StoreSettingsContext.Provider value={value}>{children}</StoreSettingsContext.Provider>;
};

export const useStoreSettings = () => {
  const context = useContext(StoreSettingsContext);
  if (!context) {
    throw new Error('useStoreSettings must be used inside StoreSettingsProvider');
  }
  return context;
};
